import BeneficiariesModal from './BeneficiariesModal';
export default BeneficiariesModal;
